module.exports = __webpack_public_path__ + "static/img/5.28a9d39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userMethods/5.png
// module id = +tOZ
// module chunks = 0